import { ctxPluto } from '@/contexts/PlutoContext';
import { useContext, useEffect, useRef } from 'react';
import TargetMeasureChannels from './TargetMeasureChannels';

import './TargetTrackingPanel.css';
import TargetTrackingDetails from './TargetTrackingDetails';
import { HeaderNameAndIcons } from '../common/HeaderNameAndIcons';

export default function TargetTrackingPanel({ activeMenuIndex }: { activeMenuIndex?: string }) {
  const ctx = useContext(ctxPluto);
  const prevMenuIndex = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (!ctx) return;
    if (activeMenuIndex !== undefined && activeMenuIndex != '' && prevMenuIndex.current !== activeMenuIndex) {
      ctx.setPopupTargetId(undefined);
    }
    return () => {
      prevMenuIndex.current = activeMenuIndex;
    };
  }, [ctx, activeMenuIndex]);

  if (ctx?.popupTargetId === undefined || ctx?.mode !== 'target') {
    return null;
  }

  const target = ctx.fullTargets?.find((t) => t.target.id === ctx?.popupTargetId);
  if (!target) {
    return null;
  }

  return (
    <div className="target-tracking-panel">
      {activeMenuIndex !== undefined && (
        <HeaderNameAndIcons
          target={target.target}
          onClose={() => ctx?.setPopupTargetId(undefined)}
          onReload={() => ctx?.setImmediateLoadTargetId(ctx?.popupTargetId)}
          hasTargetMetadataId={target.hasTachographMetadataId}
        />
      )}
      <TargetTrackingDetails target={target} />
      <TargetMeasureChannels target={target} />
    </div>
  );
}
